import { typedMemo } from "src/types";
import {
  useVehicleImpactPointCell,
  VehicleImpactPointCellProps,
} from "./vehicle-impact-point-cell.hook";

export const VehicleImpactPointCell = typedMemo(
  (props: VehicleImpactPointCellProps) => {
    const { impactPoint, onClick } = props;

    const { containerRef } = useVehicleImpactPointCell(props);

    if (!impactPoint) return <div />;

    return (
      <div
        ref={containerRef}
        onClick={onClick}
        className="cursor-pointer" 
      />
    );
  }
);
